import { c as _c } from "react/compiler-runtime";
import { GuaranteeSymbol } from "./guarantee-symbol";
import { GuaranteeContent } from "./guarantee-content";
import { Testimonial } from "./testimonial";
type AsidePanelProps = {
  showTestimonial?: boolean;
};
export function AsidePanel(t0) {
  const $ = _c(2);
  const {
    showTestimonial: t1
  } = t0;
  const showTestimonial = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== showTestimonial) {
    t2 = <div className="flex justify-center items-center w-full h-full"><div className="flex flex-col gap-3 items-center justify-center max-w-xs md:max-w-lg">{showTestimonial ? <Testimonial /> : <><GuaranteeSymbol /><GuaranteeContent /></>}</div></div>;
    $[0] = showTestimonial;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}